import { ISort } from '@hooks/useSort';
import { TableRow, TableRowProps } from '@material-ui/core';
import React from 'react';

export type TableSortRowProps = TableRowProps & {
    sort: ISort
}

export const TableSortRowContext = React.createContext<ISort | undefined>(undefined);

export function TableSortRow ({ sort, children, ...props }: TableSortRowProps) {
    return (
        <TableSortRowContext.Provider value={sort}>
            <TableRow {...props}>
                { children }
            </TableRow>
        </TableSortRowContext.Provider>
    );
}